import api from './api';

/**
 * Get user addresses for admin order placement
 * @param {number} userId - User ID
 * @returns {Promise<Object>} Response with addresses
 */
export const getUserAddresses = async (userId) => {
  const response = await api.get(`/admin/orders/admin/users/${userId}/addresses/`);
  return response.data;
};

/**
 * Create admin-assisted orders from cart items
 * @param {Object} data - Order creation data
 * @param {number} data.user_id - Target user ID
 * @param {Array<number>} data.cart_ids - Array of cart item IDs
 * @param {number} data.receiver_address_id - Optional address ID (uses default if not provided)
 * @param {Object} data.remarks - Optional remarks per cart item { cart_id: "remark" }
 * @returns {Promise<Object>} Response with created orders
 */
export const createAdminOrders = async (data) => {
  const response = await api.post('/admin/orders/admin/create/', data);
  return response.data;
};

/**
 * Get pending orders awaiting approval
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.page_size - Items per page
 * @returns {Promise<Object>} Response with pending orders
 */
export const getPendingOrders = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  
  const url = `/admin/orders/admin/pending/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const response = await api.get(url);
  return response.data;
};

/**
 * Approve an admin-assisted order
 * @param {number} orderId - Order ID
 * @param {string} approvalPin - 6-digit approval PIN
 * @returns {Promise<Object>} Response with approval result
 */
export const approveOrder = async (orderId, approvalPin) => {
  const response = await api.post(`/admin/orders/admin/${orderId}/approve/`, {
    approval_pin: approvalPin,
  });
  return response.data;
};

const orderService = {
  getUserAddresses,
  createAdminOrders,
  getPendingOrders,
  approveOrder,
};

export default orderService;
